import { DataTableExpandedRows, DataTableRowClickEvent } from 'primereact/datatable';
import { useState } from 'react';

const useSingleRowExpansion = (dataKey: string) => {
    const [expandedRows, setExpandedRows] = useState<DataTableExpandedRows>({});

    const onRowClick = (e: DataTableRowClickEvent) => {
        const target = e.originalEvent.target as HTMLElement;
        if (target && typeof target.closest === 'function' && target.closest('.p-button, .p-menu, a, input')) { return; }

        const keyValue = String((e.data as Record<string, any>)[dataKey]);
        setExpandedRows((prev) => (prev[keyValue] ? {} : { [keyValue]: true }));
    };

    const collapseAll = () => setExpandedRows({});

    return { expandedRows, onRowClick, collapseAll };
}

export default useSingleRowExpansion;
